import { render, staticRenderFns } from "./ArticleInfoCover.vue?vue&type=template&id=3e3aa0e0&scoped=true"
import script from "./ArticleInfoCover.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoCover.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoCover.vue?vue&type=style&index=0&id=3e3aa0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3aa0e0",
  null
  
)

export default component.exports